import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { IconButton } from '@material-ui/core';
import { Navbar } from 'react-bootstrap';
import MenuRounded from '@material-ui/icons/MenuRounded';
import NestedList from './list';
import DrawerLayout from './layout';
import { APP_NAV_COMPACT_BREAKPOINT_PX } from '../../constants/appLayout';

const useStyles = makeStyles({
  list: {
    width: 'min(88vw, 304px)',
    maxWidth: '100%',
  },
  fullList: {
    width: 'auto',
  },
});

type Anchor = 'top' | 'left' | 'bottom' | 'right';

export default function SwipeableEWDrawer({ anchor }: { anchor: Anchor }) {
  const classes = useStyles();
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor: Anchor, nextOpen: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent,
  ) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setState((prev) => ({ ...prev, [anchor]: nextOpen }));
  };

  const closeLeft = useCallback(() => {
    setState((prev) => ({ ...prev, left: false }));
  }, []);

  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleWindowSizeChange = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowSizeChange);
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  const isCompactNav = width <= APP_NAV_COMPACT_BREAKPOINT_PX;

  const list = (anchor: Anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <DrawerLayout onRequestClose={closeLeft}>
        <NestedList onRequestClose={closeLeft} />
      </DrawerLayout>
    </div>
  );

  return (
    <div>
      {(['left'] as Anchor[]).map((anchor) => (
        <React.Fragment key={anchor}>
          {isCompactNav && (
            <Navbar
              expand={false}
              className="ew-mobile-top-nav sticky-top"
              role="banner"
            >
              <div className="ew-mobile-top-nav__inner">
                <IconButton
                  className="ew-mobile-top-nav__menu-btn"
                  aria-label="Open navigation menu"
                  aria-controls="ew-mobile-navigation-drawer"
                  aria-expanded={state[anchor]}
                  onClick={toggleDrawer(anchor, true)}
                  disableRipple
                >
                  <MenuRounded className="ew-mobile-top-nav__menu-icon" />
                </IconButton>
              </div>
            </Navbar>
          )}
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
            transitionDuration={{ enter: 320, exit: 260 }}
            SlideProps={{
              timeout: { enter: 320, exit: 260 },
            }}
            ModalProps={{
              className: 'ew-mobile-drawer-modal',
              style: { zIndex: 10050 },
              BackdropProps: {
                className: 'ew-mobile-drawer-backdrop',
                timeout: 280,
              },
            }}
            PaperProps={{
              className: 'ew-mobile-drawer-paper',
              elevation: 0,
              id: 'ew-mobile-navigation-drawer',
            }}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
